module.exports = __webpack_public_path__ + "img/hero-1-mobile.08c25798.jpg";